module.exports = __webpack_public_path__ + "static/media/im.633be8b4.svg";